import { Button, Drawer, Form } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../AppContext';
import { PERMISSIONS_KEY, PERMISSION_TYPE } from '../common/constants';
import { hasPermission } from '../common/utils';
import LibrarianToyDetailsContent from '../libraryModules/inventory/components/ToyDetailsContent';
import ToyCreateContent from '../modules/lists/modules/toy/components/ToyCreateContent';
import ToyDetailsContent from '../modules/lists/modules/toy/components/ToyDetailsContent';
import ToyEditContent from '../modules/lists/modules/toy/components/ToyEditContent';

const ToyDetailsDrawer = () => {
  const {
    dispatch,
    state: { toyDrawer, isDesktop, permissions },
  } = useContext(AppContext);
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [toyDetail, setToyDetail] = useState({});
  const [viewKey, setViewKey] = useState(0);

  const isCreate = toyDrawer?.isCreate;

  useEffect(() => {
    if (toyDrawer?.visible) {
      setIsEditing(Boolean(toyDrawer?.isEdit));
    }
  }, [toyDrawer?.visible, toyDrawer?.toyId, toyDrawer?.isEdit]);
  const isFormMode = isCreate || isEditing;

  const stopEditing = () => {
    setIsEditing(false);
    setIsDisabled(true);
    setIsSubmitLoading(false);
    dispatch({ type: 'SET_SHOW_PROMPT', data: false });
  };

  const handleClose = () => {
    stopEditing();
    form?.resetFields();
    setToyDetail({});
    dispatch({
      type: 'SET_TOY_DRAWER',
      data: { visible: false, toyId: null },
    });
  };

  const handleSaved = () => {
    dispatch({ type: 'SET_REFETCH_TOYS', data: true });
    if (isCreate) {
      handleClose();
      return;
    }
    stopEditing();
    setViewKey((prev) => prev + 1);
  };

  const canEdit =
    !toyDrawer?.isLibrary &&
    hasPermission(
      PERMISSIONS_KEY?.MASTER_LIST_TOY,
      PERMISSION_TYPE?.UPDATE,
      permissions,
    );

  const headerNode = (
    <div className="header-text">
      <div className="header-title">
        {/* eslint-disable-next-line no-nested-ternary */}
        {isCreate ? 'Add New Toy' : isEditing ? 'Edit Toy' : 'Toy Details'}
      </div>
      {canEdit && !isFormMode && (
        <Button
          className="common-button"
          size="middle"
          onClick={() => setIsEditing(true)}
          disabled={toyDetail?.isArchived}
        >
          Edit Toy
        </Button>
      )}
      {isFormMode && (
        <div className="header-btn-wrapper">
          <Button
            type="primary"
            className="common-button mr-16"
            size="middle"
            onClick={isCreate ? handleClose : stopEditing}
          >
            {isCreate ? 'Cancel' : 'Discard Changes'}
          </Button>
          <Button
            className="common-button"
            size="middle"
            onClick={form.submit}
            loading={isSubmitLoading}
            disabled={isDisabled}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );

  const renderContent = () => {
    if (isCreate) {
      return (
        <ToyCreateContent
          form={form}
          onSaved={handleSaved}
          onDirtyChange={() => setIsDisabled(false)}
          onSubmittingChange={setIsSubmitLoading}
        />
      );
    }
    if (toyDrawer?.isLibrary) {
      return <LibrarianToyDetailsContent toyId={toyDrawer?.toyId} />;
    }
    if (isEditing) {
      return (
        <ToyEditContent
          form={form}
          toyId={toyDrawer?.toyId}
          onSaved={handleSaved}
          onDirtyChange={() => setIsDisabled(false)}
          onSubmittingChange={setIsSubmitLoading}
        />
      );
    }
    return (
      <ToyDetailsContent
        key={viewKey}
        toyId={toyDrawer?.toyId}
        onToyLoaded={setToyDetail}
      />
    );
  };

  return (
    <Drawer
      title={headerNode}
      open={toyDrawer?.visible}
      onClose={handleClose}
      width={isDesktop ? '85%' : '100%'}
      className="custom-drawer toy-details-drawer"
      destroyOnClose
    >
      {toyDrawer?.visible && renderContent()}
    </Drawer>
  );
};

export default ToyDetailsDrawer;
